import { Outlet, useMatch } from 'react-router-dom'

import { Header } from '@components/header/header'
import { BookingHeader } from 'components/booking_header/booking_header'
import { useMonitoringData } from 'hooks/use_monitoring_data'
import { routes } from 'app/routes_definitions'

export const OfferLayout = () => {
  useMonitoringData()
  const notPaymentSummary = useMatch(routes.paymentSummary.path) === null

  return (
    <>
      <Header />
      {notPaymentSummary && <BookingHeader />}
      <Outlet />
    </>
  )
}
